// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2BERV","checkboxCol":"Table_checkboxCol__1bzmb","emailCol":"Table_emailCol__11PxH","actionCol":"Table_actionCol__1d2qe"};